import styled from 'styled-components';

export default styled.span`
  color: #ff0000;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  font-family: 'futura-pt', sans-serif;
  &.api-error {
    font-size: 16px;
  }
`;
